const CurrencyDisplay = ({ amount, currency }) => {
    const formattedAmount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency
    }).format(amount);

    return <p style={{ fontFamily: "Founders Grotesk Mono", fontSize: "13px", fontWeight: 400, margin: 0}}>{formattedAmount}</p>
}
export default CurrencyDisplay